module.exports = __webpack_public_path__ + "img/belarus.88e67f34.svg";